import { logAppError } from 'Helpers/logger'
import {
  isStartDateChangedState,
  modalResumeTestState,
  modalStopSendingWinnerState,
  modalStopTestState,
  pageState,
} from '../state/page'
import getIntl from 'Helpers/intl'
import {
  abTestSetWinnerAction,
  addNewTag,
  checkScheduleAbTestByIdAction,
  cleanABTestAction,
  getABTestConfigByIdAction,
  getABTestResultByIdAction,
  getAggregateReportIDByABTestIDAction,
  getAllTags,
  getFailedSendingsAction,
  getMessageDetailsAction,
  isAbTestReschedulableAction,
  isAbTestResumableAction,
  rescheduleAbTestAction,
  resumeAbTestAction,
  scheduleAbTestByIdAction,
  scheduleAbTestWinnerAction,
  stopABTestAction,
  updateABTestConfigAction,
  updateABTestResultsAction,
} from '../actions/actions'
import { abTestState, tagsListState } from '../state/abTest'
import {
  ABTEST_SCHEDULEDSTATUS_SCHEDULED,
  ABTEST_SCHEDULEDSTATUS_SUGGESTBOTHDATE,
  ABTEST_SCHEDULEDSTATUS_SUGGESTEDTESTDATE,
  ABTEST_SCHEDULEDSTATUS_SUGGESTEDWINNERDATE,
  ABTEST_STATUS_COMPLETED,
  ABTEST_STATUS_SENDING_OF_TEST_MESSAGES_COMPLETED,
  ABTEST_STATUS_SENDING_OF_TEST_MESSAGES_STARTED,
  ABTEST_STATUS_SENDING_OF_WINNER_MESSAGE_STARTED,
  ABTEST_STATUS_STOP_DURING_TEST,
  ABTEST_STATUS_STOP_DURING_WINNER,
  ABTEST_STATUS_SUGGESTED_TEST_DATE,
  ABTEST_STATUS_SUGGESTED_WINNER_DATE,
  ABTEST_STATUS_WAITING_FOR_SENDING_OF_TEST_MESSAGES,
  ABTEST_STATUS_WINNER_MESSAGE_DEFINED,
  ABTEST_STATUS_WINNER_MESSAGE_SCHEDULED,
} from 'Api/beABTestApi'
import { useHistory } from 'react-router-dom'
import {
  toastShow,
  TOAST_VARIANT_WARNING,
  TOAST_VARIANT_SUCCESS,
  TOAST_VARIANT_ERROR,
} from 'mailup-web-components'
import { contentScheduledState } from 'Components/ContentScheduled/recoil/state'
import moment from 'moment-timezone'
import { zones } from 'mailup-react-helpers'
import { getLocaleDate } from 'Helpers/dates'

export const resetCallback =
  ({ set, reset }) =>
  async (id) => {
    reset(pageState)
    reset(tagsListState)
    reset(abTestState)
    reset(modalResumeTestState)
    reset(modalStopTestState)
    reset(modalStopSendingWinnerState)
  }

export const initAbTestManageCallback =
  ({ set }) =>
  async (id) => {
    set(pageState, (prev) => ({ ...prev, loading: true, loaded: false }))
    const idABTest = parseInt(id, 0)
    try {
      const [tagsList, abTestData, idAggregateReport] = await Promise.all([
        getAllTags(),
        getABTestConfigByIdAction(idABTest),
        getAggregateReportIDByABTestIDAction(idABTest),
      ])
      set(abTestState, {
        ...abTestData,
        idAggregateReport: idAggregateReport,
        disableStatBtn: idAggregateReport === 0,
      })

      const idSends = []
      let respExistsFailedSending = null
      for (let i = 0; i < abTestData.Messages.length; i++) {
        // abTestData.Messages.forEach(async message => {
        const message = abTestData.Messages[i]

        if (
          abTestData.Info.Stato !==
            ABTEST_STATUS_WAITING_FOR_SENDING_OF_TEST_MESSAGES &&
          (abTestData.Info.Stato === ABTEST_STATUS_SUGGESTED_WINNER_DATE ||
            abTestData.Info.Stato === ABTEST_STATUS_COMPLETED ||
            (abTestData.Info.TipoTest === 'M' &&
              abTestData.Info.Stato ===
                ABTEST_STATUS_WINNER_MESSAGE_SCHEDULED) ||
            abTestData.Info.Stato === ABTEST_STATUS_STOP_DURING_WINNER ||
            message.TipoInvio === 1)
        ) {
          const msgDett = await getMessageDetailsAction(message.IdMessaggio)

          set(abTestState, (prev) => ({
            ...prev,
            Messages: prev.Messages.map((a) =>
              a.IdMessaggio === message.IdMessaggio
                ? {
                    ...a,
                    Subject: msgDett.Subject,
                    Note: msgDett.Note,
                    hasThumbnail: msgDett.HasThumbnail,
                    updateDate: msgDett.LastUpdated,
                  }
                : a,
            ),
          }))
        }
        if (
          [
            ABTEST_STATUS_SENDING_OF_TEST_MESSAGES_STARTED,
            ABTEST_STATUS_WINNER_MESSAGE_DEFINED,
            ABTEST_STATUS_SENDING_OF_WINNER_MESSAGE_STARTED,
            ABTEST_STATUS_SENDING_OF_TEST_MESSAGES_COMPLETED,
            ABTEST_STATUS_WINNER_MESSAGE_SCHEDULED,
            ABTEST_STATUS_COMPLETED,
            ABTEST_STATUS_STOP_DURING_TEST,
            ABTEST_STATUS_STOP_DURING_WINNER,
          ].indexOf(abTestData.Info.Stato) >= 0
        ) {
          idSends.push(message.IdInvio)
        }
      }
      if (
        [
          ABTEST_STATUS_SENDING_OF_TEST_MESSAGES_STARTED,
          ABTEST_STATUS_WINNER_MESSAGE_DEFINED,
          ABTEST_STATUS_SENDING_OF_WINNER_MESSAGE_STARTED,
          ABTEST_STATUS_SENDING_OF_TEST_MESSAGES_COMPLETED,
          ABTEST_STATUS_WINNER_MESSAGE_SCHEDULED,
          ABTEST_STATUS_COMPLETED,
          ABTEST_STATUS_STOP_DURING_TEST,
          ABTEST_STATUS_STOP_DURING_WINNER,
        ].indexOf(abTestData.Info.Stato) >= 0
      ) {
        respExistsFailedSending = await getFailedSendingsAction(idSends)
      }

      let showReplanBtn = false
      let showPlanBtn = false
      let startWinnerMessageDate = ''
      let showInfoMessageScheduledBoxConfig = false
      if (
        abTestData.Info.TipoTest === 'A' ||
        abTestData.Info.TipoTest === 'M'
      ) {
        if (
          abTestData.Info.Stato ===
            ABTEST_STATUS_SENDING_OF_TEST_MESSAGES_STARTED ||
          abTestData.Info.Stato === ABTEST_STATUS_WINNER_MESSAGE_DEFINED ||
          abTestData.Info.Stato ===
            ABTEST_STATUS_SENDING_OF_TEST_MESSAGES_COMPLETED ||
          abTestData.Info.Stato === ABTEST_STATUS_WINNER_MESSAGE_SCHEDULED
        ) {
          if (abTestData.Info.TipoTest === 'M') {
            if (
              abTestData.Info.Stato === ABTEST_STATUS_WINNER_MESSAGE_SCHEDULED
            ) {
              startWinnerMessageDate = abTestData.Info.WinnerDateCTZScheduled
              if (
                abTestData.Info.Stato !==
                ABTEST_STATUS_SENDING_OF_TEST_MESSAGES_STARTED
              ) {
                showReplanBtn = true
                showPlanBtn = false
              }
            } else {
              startWinnerMessageDate = moment()
                .add(6, 'minutes')
                .format('YYYY-MM-DDTHH:mm:ss.SSSZZ')

              if (
                abTestData.Info.Stato !==
                ABTEST_STATUS_SENDING_OF_TEST_MESSAGES_STARTED
              ) {
                showReplanBtn = false
                showPlanBtn = true
              }
            }
          }
          if (abTestData.Info.TipoTest === 'A') {
            if (
              abTestData.Info.Stato === ABTEST_STATUS_WINNER_MESSAGE_SCHEDULED
            ) {
              startWinnerMessageDate = abTestData.Info.WinnerDateCTZScheduled
              if (
                abTestData.Info.Stato !==
                ABTEST_STATUS_SENDING_OF_TEST_MESSAGES_STARTED
              ) {
                showReplanBtn = true
                showPlanBtn = false
              }
            }
          }
          if (
            abTestData.Info.Stato ===
            ABTEST_STATUS_SENDING_OF_TEST_MESSAGES_STARTED
          ) {
            showReplanBtn = false
            showInfoMessageScheduledBoxConfig = true
          }
        }
      }

      set(abTestState, (prev) => ({
        ...prev,
        existsFailedSending: respExistsFailedSending
          ? respExistsFailedSending.Value.length > 0
          : false,
        testRunning:
          abTestData.Info.Stato ===
          ABTEST_STATUS_SENDING_OF_TEST_MESSAGES_STARTED,
        testEnded:
          abTestData.Info.Stato === ABTEST_STATUS_WINNER_MESSAGE_DEFINED ||
          abTestData.Info.Stato ===
            ABTEST_STATUS_SENDING_OF_TEST_MESSAGES_COMPLETED ||
          abTestData.Info.Stato === ABTEST_STATUS_WINNER_MESSAGE_SCHEDULED,
        sendingWinner:
          abTestData.Info.Stato === ABTEST_STATUS_SUGGESTED_WINNER_DATE,
        testCompleted: abTestData.Info.Stato === ABTEST_STATUS_COMPLETED,
        testStopped: abTestData.Info.Stato === ABTEST_STATUS_STOP_DURING_TEST,
        winnerSendStopped:
          abTestData.Info.Stato === ABTEST_STATUS_STOP_DURING_WINNER,
        testNotStartMode:
          abTestData.Info.Stato ===
          ABTEST_STATUS_WAITING_FOR_SENDING_OF_TEST_MESSAGES,
        winnerMessageScheduledManualMode:
          abTestData.Info.TipoTest === 'M' &&
          abTestData.Info.Stato === ABTEST_STATUS_WINNER_MESSAGE_SCHEDULED,
        showStopTestBtn:
          abTestData.Info.Stato === ABTEST_STATUS_SUGGESTED_TEST_DATE ||
          abTestData.Info.Stato === ABTEST_STATUS_WINNER_MESSAGE_DEFINED ||
          abTestData.Info.Stato ===
            ABTEST_STATUS_SENDING_OF_TEST_MESSAGES_COMPLETED ||
          abTestData.Info.Stato === ABTEST_STATUS_WINNER_MESSAGE_SCHEDULED,
        showStopSendWinnerBtn:
          abTestData.Info.Stato === ABTEST_STATUS_SUGGESTED_WINNER_DATE,
        schedulingAutomatic: parseInt(
          abTestData.Info.WinnerIntervalSecondsScheduled / 3600,
        ),
        showReplanBtn: showReplanBtn,
        showPlanBtn: showPlanBtn,
        startWinnerMessageDate: startWinnerMessageDate,
        showInfoMessageScheduledBoxConfig: showInfoMessageScheduledBoxConfig,
      }))

      set(tagsListState, (prev) => ({ ...prev, tagsList: tagsList.Items }))

      set(pageState, (prev) => ({
        ...prev,
        loading: false,
        loaded: true,
        error: '',
      }))

      return true
    } catch (error) {
      logAppError({
        Component: 'ABTestManage',
        Method: 'initAbTestManageCallback',
        appError: error,
      })
      set(pageState, (prev) => ({
        ...prev,
        error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
        severity: 'danger',
        loaded: true,
      }))
    }
  }

export const getABTestResultCallback =
  ({ set }) =>
  async (id) => {
    try {
      set(pageState, (prev) => ({ ...prev, loadingResult: true }))

      await getABTestResultByIdAction(id)

      const res = await updateABTestResultsAction(id)

      res.results.ProcessedResults.forEach((r) => {
        set(abTestState, (prev) => ({
          ...prev,
          Messages: prev.Messages.map((a) =>
            a.IdMessaggio === r.idMessaggio
              ? {
                  ...a,
                  OpenRate: r.openRate,
                  ClickRate: r.clickRate,
                  AbuseRate: r.abuseRate,
                  DeltaOpenRate: r.deltaOpenRate,
                  DeltaClickRate: r.deltaClickRate,
                  DeltaAbuseRate: r.deltaAbuseRate,
                }
              : a,
          ),
          maxOpenRate: res.results.ProcessedResults.map(
            (m) => m.openRate,
          ).reduce((a, b) => {
            return Math.max(a, b)
          }),
          maxClickRate: res.results.ProcessedResults.map(
            (m) => m.clickRate,
          ).reduce((a, b) => {
            return Math.max(a, b)
          }),
          maxAbuseRate: res.results.ProcessedResults.map(
            (m) => m.abuseRate,
          ).reduce((a, b) => {
            return Math.max(a, b)
          }),
        }))
      })
    } catch (error) {
      logAppError({
        Component: 'getABTestResultCallback',
        Method: 'addNewTagCallback',
        appError: error,
      })
      set(pageState, (prev) => ({
        ...prev,
        error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
        severity: 'danger',
      }))
    }
    set(pageState, (prev) => ({ ...prev, loadingResult: false }))
  }

export const addNewTagCallback =
  ({ set, snapshot }) =>
  async (pTagName) => {
    const { Tags } = await snapshot.getPromise(abTestState)

    try {
      const newTag = await addNewTag(pTagName)
      const tagsList = await getAllTags()

      set(tagsListState, (prev) => ({ ...prev, tagsList: tagsList.Items }))

      set(abTestState, (prev) => ({
        ...prev,
        Tags: [...Tags, newTag.Id],
        IsDirty: true,
      }))
    } catch (error) {
      logAppError({
        Component: 'ABTestManage',
        Method: 'addNewTagCallback',
        appError: error,
      })
      set(pageState, (prev) => ({
        ...prev,
        error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
        severity: 'danger',
      }))
    }
  }

export const saveAndRescheduleCallback =
  ({ set, snapshot }) =>
  async (id) => {
    const {
      IsDirty,
      Info,
      Tags,
      schedulingAutomaticIsDirty,
      schedulingAutomatic,
    } = await snapshot.getPromise(abTestState)
    const isStartDateChanged = await snapshot.getPromise(
      isStartDateChangedState,
    )
    const {
      momentTimeZoneDate,
      timeZone,
      isDirty: contentScheduledStateIsDiry,
    } = await snapshot.getPromise(contentScheduledState)

    try {
      set(pageState, (prev) => ({ ...prev, loading: true }))
      if (IsDirty) {
        await updateABTestConfigAction({
          ABTestID: Info.ABTestID,
          Nome: Info.Nome,
          Tags: Tags,
        })
      }

      if (!isStartDateChanged && !schedulingAutomaticIsDirty) {
        toastShow(
          getIntl().formatMessage({ id: 'Load.ABTestManage.SuccessScheduled' }),
          TOAST_VARIANT_SUCCESS,
          'SuccessScheduled',
        )
        set(abTestState, (prev) => ({ ...prev, IsDirty: false }))
      } else {
        const isAbTestReschedulable = await isAbTestReschedulableAction(
          Info.ABTestID,
        )
        if (!isAbTestReschedulable) {
          toastShow(
            getIntl().formatMessage({
              id: 'Load.AbTest.isNotAbTestReschedulable',
            }),
            TOAST_VARIANT_WARNING,
            'isNotAbTestReschedulable',
          )
        } else {
          const checkScheduleAbTestResp = await checkScheduleAbTestByIdAction(
            Info.ABTestID,
            timeZone ? timeZone : Info.TimeZoneScheduled,
            {
              ABTestMsgDateCTZ: contentScheduledStateIsDiry
                ? momentTimeZoneDate
                    .clone()
                    .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
                : Info.TestDateCTZScheduled,
              ABTestWinnerMsgDateInSeconds: schedulingAutomatic * 3600,
            },
          )

          if (
            checkScheduleAbTestResp.ABTestScheduledResult !==
            ABTEST_SCHEDULEDSTATUS_SCHEDULED
          ) {
            set(pageState, (prev) => ({ ...prev, loading: false }))
            if (
              checkScheduleAbTestResp.ABTestScheduledResult ===
                ABTEST_SCHEDULEDSTATUS_SUGGESTEDTESTDATE ||
              checkScheduleAbTestResp.ABTestScheduledResult ===
                ABTEST_SCHEDULEDSTATUS_SUGGESTBOTHDATE
            ) {
              if (checkScheduleAbTestResp.ABTestMsgDateCTZ) {
                const momentUtcDate = moment(
                  checkScheduleAbTestResp.ABTestMsgDateUTC,
                ).utc()
                const momentTimeZoneDate = moment.tz(
                  momentUtcDate,
                  zones[checkScheduleAbTestResp.TimeZoneInternalCode],
                )

                set(contentScheduledState, (prev) => ({
                  ...prev,
                  momentTimeZoneDate,
                  momentUtcDate,
                  timeZone: checkScheduleAbTestResp.TimeZoneInternalCode,
                }))

                const date =
                  checkScheduleAbTestResp.ABTestMsgDateCTZ.replace('T', ' ')
                    .replace('Z', ' ')
                    .split('.')[0] +
                  ' ' +
                  checkScheduleAbTestResp.TimeZoneInternalCode.split('.')[0]

                const warning =
                  getIntl().formatMessage({
                    id: 'Load.ABTestingSchedule.WarningTestSchedulingFirstAvailable',
                  }) +
                  ' ' +
                  date +
                  '. ' +
                  getIntl().formatMessage({
                    id: 'Load.ABTestingSchedule.WarningGenericSchedulingFirstAvailable',
                  })

                toastShow(
                  warning,
                  TOAST_VARIANT_WARNING,
                  'WarningTestSchedulingFirstAvailable',
                )
              } else {
                // Il servizio non è riuscito a schedulare l'invio di test
                toastShow(
                  getIntl().formatMessage({
                    id: 'Load.ABTestingSchedule.WarningTestSchedulingNotAvailable',
                  }),
                  TOAST_VARIANT_WARNING,
                  'WarningTestSchedulingNotAvailable',
                )
              }
            }
            if (
              checkScheduleAbTestResp.ABTestScheduledResult ===
                ABTEST_SCHEDULEDSTATUS_SUGGESTEDWINNERDATE ||
              checkScheduleAbTestResp.ABTestScheduledResult ===
                ABTEST_SCHEDULEDSTATUS_SUGGESTBOTHDATE
            ) {
              if (Info.TipoTest === 'A') {
                if (checkScheduleAbTestResp.ABTestWinnerMsgDateInSeconds) {
                  const hours = Math.floor(
                    checkScheduleAbTestResp.ABTestWinnerMsgDateInSeconds / 3600,
                  )
                  set(abTestState, (prev) => ({
                    ...prev,
                    schedulingAutomatic: hours,
                    IsDirty: true,
                  }))

                  const warning =
                    getIntl().formatMessage({
                      id: 'Load.ABTestingSchedule.WarningWinnerSchedulingFirstAvailable',
                    }) +
                    ' ' +
                    hours +
                    ' ' +
                    getIntl().formatMessage({
                      id: 'Load.ABTestingSchedule.SendWinnerAfterOnlyHours',
                    }) +
                    ' ' +
                    getIntl().formatMessage({
                      id: 'Load.ABTestingSchedule.WarningGenericSchedulingFirstAvailable',
                    })

                  toastShow(
                    warning,
                    TOAST_VARIANT_WARNING,
                    'WarningWinnerSchedulingFirstAvailable',
                  )
                } else {
                  // Il servizio non è riuscito a schedulare l'invio di test
                  toastShow(
                    getIntl().formatMessage({
                      id: 'Load.ABTestingSchedule.WarningTestSchedulingNotAvailable',
                    }),
                    TOAST_VARIANT_WARNING,
                    'WarningTestSchedulingNotAvailable',
                  )
                }
              }
            }
          } else {
            const rescheduleAbTestResp = await rescheduleAbTestAction(
              Info.ABTestID,
            )
            if (!rescheduleAbTestResp) {
              set(pageState, (prev) => ({ ...prev, loading: false }))
              toastShow(
                getIntl().formatMessage({
                  id: 'Load.AbTest.RescheduleAbTestFail',
                }),
                TOAST_VARIANT_WARNING,
                'RescheduleAbTestFail',
              )
            } else {
              const scheduleAbTestByIdResp = await scheduleAbTestByIdAction(
                Info.ABTestID,
                timeZone ? timeZone : Info.TimeZoneScheduled,
                {
                  ABTestMsgDateCTZ: momentTimeZoneDate
                    .clone()
                    .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
                  ABTestWinnerMsgDateInSeconds: schedulingAutomatic * 3600,
                },
              )

              if (
                scheduleAbTestByIdResp.ABTestScheduledResult ===
                ABTEST_SCHEDULEDSTATUS_SCHEDULED
              ) {
                set(abTestState, (prev) => ({
                  ...prev,
                  Info: {
                    ...prev.Info,
                    TestDateCTZScheduled: momentTimeZoneDate
                      .clone()
                      .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
                    TimeZoneScheduled: timeZone
                      ? timeZone
                      : Info.TimeZoneScheduled,
                  },
                }))

                toastShow(
                  getIntl().formatMessage({
                    id: 'Load.ABTestManage.SuccessSaved',
                  }),
                  TOAST_VARIANT_SUCCESS,
                  'SuccessSaved',
                )

                set(abTestState, (prev) => ({ ...prev, IsDirty: false }))
              } else {
                set(pageState, (prev) => ({ ...prev, loading: false }))

                if (
                  scheduleAbTestByIdResp.ABTestScheduledResult ===
                    ABTEST_SCHEDULEDSTATUS_SUGGESTEDTESTDATE ||
                  scheduleAbTestByIdResp.ABTestScheduledResult ===
                    ABTEST_SCHEDULEDSTATUS_SUGGESTBOTHDATE
                ) {
                  if (scheduleAbTestByIdResp.ABTestMsgDateCTZ) {
                    const momentUtcDate = moment(
                      scheduleAbTestByIdResp.ABTestMsgDateUTC,
                    ).utc()
                    const momentTimeZoneDate = moment.tz(
                      momentUtcDate,
                      zones[scheduleAbTestByIdResp.TimeZoneInternalCode],
                    )

                    set(contentScheduledState, (prev) => ({
                      ...prev,
                      momentTimeZoneDate,
                      momentUtcDate,
                      timeZone: scheduleAbTestByIdResp.TimeZoneInternalCode,
                    }))

                    const date =
                      scheduleAbTestByIdResp.ABTestMsgDateCTZ.replace('T', ' ')
                        .replace('Z', ' ')
                        .split('.')[0] +
                      ' ' +
                      checkScheduleAbTestResp.TimeZoneInternalCode.split('.')[0]

                    const warning =
                      getIntl().formatMessage({
                        id: 'Load.ABTestingSchedule.WarningTestSchedulingFirstAvailable',
                      }) +
                      ' ' +
                      date +
                      '. ' +
                      getIntl().formatMessage({
                        id: 'Load.ABTestingSchedule.WarningGenericSchedulingFirstAvailable',
                      })

                    toastShow(
                      warning,
                      TOAST_VARIANT_WARNING,
                      'WarningTestSchedulingFirstAvailable',
                    )
                  } else {
                    // Il servizio non è riuscito a schedulare l'invio di test
                    toastShow(
                      getIntl().formatMessage({
                        id: 'Load.ABTestingSchedule.WarningTestSchedulingNotAvailable',
                      }),
                      TOAST_VARIANT_WARNING,
                      'WarningTestSchedulingNotAvailable',
                    )
                  }
                }
                if (
                  scheduleAbTestByIdResp.ABTestScheduledResult ===
                    ABTEST_SCHEDULEDSTATUS_SUGGESTEDWINNERDATE ||
                  scheduleAbTestByIdResp.ABTestScheduledResult ===
                    ABTEST_SCHEDULEDSTATUS_SUGGESTBOTHDATE
                ) {
                  if (Info.TipoTest === 'A') {
                    if (scheduleAbTestByIdResp.ABTestWinnerMsgDateInSeconds) {
                      const hours = Math.floor(
                        scheduleAbTestByIdResp.ABTestWinnerMsgDateInSeconds /
                          3600,
                      )
                      set(abTestState, (prev) => ({
                        ...prev,
                        schedulingAutomatic: hours,
                        IsDirty: true,
                      }))

                      const warning =
                        getIntl().formatMessage({
                          id: 'Load.ABTestingSchedule.WarningWinnerSchedulingFirstAvailable',
                        }) +
                        ' ' +
                        hours +
                        ' ' +
                        getIntl().formatMessage({
                          id: 'Load.ABTestingSchedule.SendWinnerAfterOnlyHours',
                        }) +
                        ' ' +
                        getIntl().formatMessage({
                          id: 'Load.ABTestingSchedule.WarningGenericSchedulingFirstAvailable',
                        })

                      toastShow(
                        warning,
                        TOAST_VARIANT_WARNING,
                        'WarningWinnerSchedulingFirstAvailable',
                      )
                    } else {
                      // Il servizio non è riuscito a schedulare l'invio di test
                      toastShow(
                        getIntl().formatMessage({
                          id: 'Load.ABTestingSchedule.WarningTestSchedulingNotAvailable',
                        }),
                        TOAST_VARIANT_WARNING,
                        'WarningTestSchedulingNotAvailable',
                      )
                    }
                  }
                }
              }
            }
          }
        }
      }
    } catch (error) {
      logAppError({
        Component: 'ABTestManage',
        Method: 'addNewTagCallback',
        appError: error,
      })
      set(pageState, (prev) => ({
        ...prev,
        error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
        severity: 'danger',
      }))
    }
    set(pageState, (prev) => ({ ...prev, loading: false }))
  }

export const checkResumeTestCallback =
  ({ set, snapshot }) =>
  async (id) => {
    set(pageState, (prev) => ({ ...prev, loading: true }))
    try {
      const resp = isAbTestResumableAction(id)

      if (resp) {
        set(modalResumeTestState, (prev) => ({ showModalResumeTest: true }))
      } else {
        toastShow(
          getIntl().formatMessage({ id: 'Load.AbTest.ResumeTestWarning' }),
          TOAST_VARIANT_WARNING,
          'ResumeTestWarning',
        )
      }
    } catch (error) {
      logAppError({
        Component: 'ABTestManage',
        Method: 'checkResumeTestCallback',
        appError: error,
      })
      set(pageState, (prev) => ({
        ...prev,
        error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
        severity: 'danger',
      }))
    }
    set(pageState, (prev) => ({ ...prev, loading: false }))
  }

export const resumeTestCallback =
  ({ set, snapshot }) =>
  async (id) => {
    set(pageState, (prev) => ({ ...prev, loading: true }))
    let resp
    try {
      resp = await resumeAbTestAction(id)

      set(abTestState, (prev) => ({
        testStopped: false,
        winnerSendStopped: false,
      }))
      return resp
    } catch (error) {
      logAppError({
        Component: 'ABTestManage',
        Method: 'checkResumeTestCallback',
        appError: error,
      })
      set(pageState, (prev) => ({
        ...prev,
        error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
        severity: 'danger',
      }))
    }
    set(pageState, (prev) => ({ ...prev, loading: false }))
  }

export const cleanABTestCallback =
  ({ set, snapshot }) =>
  async (id) => {
    const history = useHistory()
    set(pageState, (prev) => ({ ...prev, loading: true }))
    try {
      const resp = cleanABTestAction(id)

      if (resp) {
        history.push('/messages/email/sendstatus/campaigns')
      } else {
        toastShow(
          getIntl().formatMessage({ id: 'Load.AbTest.CleanABTestFail' }),
          TOAST_VARIANT_WARNING,
          'CleanABTestFail',
        )
      }
    } catch (error) {
      logAppError({
        Component: 'ABTestManage',
        Method: 'cleanABTestCallback',
        appError: error,
      })
      set(pageState, (prev) => ({
        ...prev,
        error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
        severity: 'danger',
      }))
    }
    set(pageState, (prev) => ({ ...prev, loading: false }))
  }

export const stopTestCallback =
  ({ set, snapshot }) =>
  async (id) => {
    set(pageState, (prev) => ({ ...prev, loading: true }))
    let resp
    try {
      resp = stopABTestAction(id)
      set(abTestState, (prev) => ({
        testStopped: false,
        winnerSendStopped: false,
      }))
      return resp
    } catch (error) {
      logAppError({
        Component: 'ABTestManage',
        Method: 'checkResumeTestCallback',
        appError: error,
      })
      set(pageState, (prev) => ({
        ...prev,
        error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
        severity: 'danger',
      }))
    }
    set(pageState, (prev) => ({ ...prev, loading: false }))
  }

const scheduleWinner = async (snapshot, set) => {
  set(pageState, (prev) => ({ ...prev, loading: true }))
  try {
    const { Info } = await snapshot.getPromise(abTestState)
    const { momentTimeZoneDate } = await snapshot.getPromise(
      contentScheduledState,
    )

    const scheduleAbTestResp = await scheduleAbTestWinnerAction(
      Info.ABTestID,
      momentTimeZoneDate.format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
    )
    if (scheduleAbTestResp) {
      toastShow(
        getIntl().formatMessage({ id: 'Load.ABTestManage.SuccessScheduled' }),
        TOAST_VARIANT_SUCCESS,
        'SuccessScheduled',
      )
      set(abTestState, (prev) => ({ ...prev, IsDirty: false }))
      return true
    } else {
      const startWinnerMessageDate = moment()
        .add(6, 'minutes')
        .format('YYYY-MM-DDTHH:mm:ss.SSSZZ')

      const date =
        scheduleAbTestResp.ABTestMsgDateCTZ.replace('T', ' ')
          .replace('Z', ' ')
          .split('.')[0] +
        ' ' +
        scheduleAbTestResp.TimeZoneInternalCode.split('.')[0]
      const warning =
        getIntl().formatMessage({
          id: 'Load.ABTestingSchedule.WarningTestSchedulingFirstAvailable',
        }) +
        ' ' +
        date +
        '. ' +
        getIntl().formatMessage({
          id: 'Load.ABTestingSchedule.WarningGenericSchedulingFirstAvailable',
        })

      toastShow(
        warning,
        TOAST_VARIANT_WARNING,
        'WarningTestSchedulingFirstAvailable2',
      )

      set(abTestState, (prev) => ({
        ...prev,
        startWinnerMessageDate: startWinnerMessageDate.toString(),
      }))
      return false
    }
  } catch (error) {
    logAppError({
      Component: 'ABTestManage',
      Method: 'scheduleWinnerTestCallback',
      appError: error,
    })

    toastShow(
      getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      TOAST_VARIANT_ERROR,
      'ErrorGeneric',
    )
  }

  set(pageState, (prev) => ({ ...prev, loading: false }))
}

export const rePlanAbTestWinnerCallback =
  ({ set, snapshot }) =>
  async () => {
    return scheduleWinner(snapshot, set)
  }

export const winnerPlanCallback =
  ({ set, snapshot }) =>
  async () => {
    set(pageState, (prev) => ({ ...prev, loading: true }))
    try {
      const { Info, idWinnerMessageManual } =
        await snapshot.getPromise(abTestState)
      const resp = await abTestSetWinnerAction(
        Info.ABTestID,
        idWinnerMessageManual,
      )
      if (resp) {
        return scheduleWinner(snapshot, set)
      } else {
        toastShow(
          getIntl().formatMessage({ id: 'Load.AbTest.SetWinnerMessageError' }),
          TOAST_VARIANT_WARNING,
          'SetWinnerMessageError',
        )
      }
    } catch (error) {
      logAppError({
        Component: 'ABTestManage',
        Method: 'winnerPlanCallback',
        appError: error,
      })
      set(pageState, (prev) => ({
        ...prev,
        error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
        severity: 'danger',
      }))
    }
    set(pageState, (prev) => ({ ...prev, loading: false }))
  }
